<template>
  <div>
    <!-- basic modal -->
    <!-- <b-modal id="cropperModal" ref="cropperModal" scrollable size="lg" cancel-variant="outline-secondary" :hideHeaderClose="true" no-close-on-backdrop cancel-title="Close" ok-title="Crop" @hidden="resetModal" @ok="handleOk">
      <vue-cropper v-if="selectedImage" ref="cropper" :src="selectedImage" :view-mode="0" :aspect-ratio="ratio" />
    </b-modal> -->

    <b-modal id="cropperModal" ref="cropperModal" scrollable size="lg" cancel-variant="outline-secondary" :hideHeaderClose="true" no-close-on-backdrop cancel-title="Close" ok-title="Crop" @hidden="resetModal" @ok="handleOk">
      <vue-cropper v-if="selectedImage" ref="cropper" :src="selectedImage" :view-mode="0" :aspect-ratio="ratio" />

      <b-row class="justify-content-center text-center mt-50">
        <button class="btn ql-bold bg-primary text-white mr-1" @click="rotateRightImage"><feather-icon icon="CornerUpRightIcon" size="20" /> Rotate Right 90°</button>
        <button class="btn ql-bold bg-primary text-white mr-1" @click="rotateLeftImage"><feather-icon icon="CornerUpLeftIcon" size="20" /> Rotate Left 90°</button>
        <button class="btn ql-bold bg-primary text-white mr-1" @click="flipVertical"><feather-icon icon="MoreVerticalIcon" size="20" /> Flip Vertical</button>
        <button class="btn ql-bold bg-primary text-white" @click="flipHorizontal"><feather-icon icon="MoreHorizontalIcon" size="20" /> Flip Horizontal</button>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import VueCropper from 'vue-cropperjs';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cropperjs/dist/cropper.css';
import Ripple from 'vue-ripple-directive';
export default {
  components: {
    BModal,
    VueCropper,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    ratio: { type: Number, default: 1.5 },
    image: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedImage: null,
    };
  },
  watch: {
    image(val) {
      if (val != null) {
        this.$refs.cropperModal.show();
      }
    },
  },
  mounted() {
    if (this.image != null) {
      this.selectedImage = this.image;
      this.$refs.cropperModal.show();
    }
  },
  methods: {
    handleOk() {
      const croppedImage = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.$emit('cropped', croppedImage);
    },
    resetModal() {
      this.$emit('cropped', null);
    },

    rotateRightImage() {
      this.$refs.cropper.rotate(90);
    },

    rotateLeftImage() {
      this.$refs.cropper.rotate(-90);
    },
    flipVertical() {
      this.isFlippedVertical = !this.isFlippedVertical;
      const scaleY = this.isFlippedVertical ? -1 : 1;
      this.$refs.cropper.scaleY(scaleY);
    },
    flipHorizontal() {
      this.isFlippedHorizontal = !this.isFlippedHorizontal;
      const scaleX = this.isFlippedHorizontal ? -1 : 1;
      this.$refs.cropper.scaleX(scaleX);
    },
  },
};
</script>
